<template>

  <div class="container container-tabs">

    <el-tabs v-model="activeName" @tab-click="handleClick" type="card">

      <el-tab-pane name="all" class="to-searh">
        <span slot="label" class="table-title">全部</span>
      </el-tab-pane>

      <el-tab-pane :name="String(item.val)" v-for="(item, index) in value_status_array" :key="index" class="to-searh">
        <span slot="label" class="table-title">{{ item.alias }}</span>
      </el-tab-pane>

      <div class="handle-box">


        <el-row class="head-search">
          <el-col :span="8">
            <span class="title">司机名称:</span>
            <!-- 搜索司机名称-->
            <el-input v-model="search_data.real_name" placeholder="请输入司机真实姓名 " class="handle-input mr10"
              @keyup.enter.native="searchVerifyLists"></el-input>
          </el-col>

          <el-col :span="8">
            <span class="title">身份证号码:</span>
            <!-- 搜索手机号码 -->
            <el-input v-model="search_data.id_card" placeholder="请输入身份证号码" class="handle-input mr10"
              @keyup.enter.native="searchVerifyLists"></el-input>
            </el-input>
          </el-col>



        </el-row>




        <el-button type="primary" icon="el-icon-search" @click="searchVerifyLists">搜索</el-button>

        <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>






      </div>

</el-tabs>



    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
      @selection-change="handleSelectionChange">


      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <!-- 表格下拉 -->
            <div class="more-style">

              <el-form-item label="判定时间:">
                <span>{{ props.row.verify_time.Ymd }}</span>
              </el-form-item>

              <el-form-item label="判定详细时间:">
                <span>{{ props.row.verify_time.YmdHis }}</span>
              </el-form-item>

              <el-form-item label="添加审核时间:">
                <span>{{ props.row.time.Ymd }}</span>
              </el-form-item>


            </div>

            <div class="more-style">

              <el-form-item label="添加审核详细时间:">
                <span>{{ props.row.time.YmdHis }}</span>
              </el-form-item>


              <el-form-item label="驾驶证领取时间:">
                <span>{{ props.row.driver_time.Ymd }}</span>
              </el-form-item>



            </div>

            <el-form-item label="判定备注:">
              <span>{{ props.row.verify_remarks }}</span>
            </el-form-item>

          </el-form>
        </template>
      </el-table-column>





      <el-table-column prop="id" label="id" width="80">

      </el-table-column>

      <el-table-column prop="name" label="真实姓名">

        <template slot-scope="scope">
          <el-popover trigger="hover" placement="top">
            <p>司机编码: {{ scope.row.driver_code }}</p>
            <div slot="reference">
              <el-tag size="medium" style="border:0;background-color:#FFF;color:#333">
                {{ scope.row.real_name }}
              </el-tag>
            </div>
          </el-popover>
        </template>

      </el-table-column>

      <el-table-column prop="id_card" label="身份证号" min-width="150">
      </el-table-column>

      <el-table-column prop="driver_card_mode.val" label="驾驶证型号">
      </el-table-column>

      <el-table-column label="审核判定状态">

        <template slot-scope="scope">
          <el-tag :type="scope.row.verify_status.val =='0'?'warning':(scope.row.verify_status.val=='1'?'':'danger')">
            {{scope.row.verify_status.alias}}</el-tag>
        </template>

      </el-table-column>



      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <el-dropdown split-button trigger="click" type="primary"
            @click="determine_isShow = !determine_isShow; determine_drawer = scope.row.driver_code ">
            审核判定

            <el-dropdown-menu slot="dropdown">

              <el-dropdown-item
                @click.native="determineContent_show = !determineContent_show;determine_drawer = scope.row.driver_code">
                查看审核内容</el-dropdown-item>

            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>


    <!-- 分页组件 -->
    <div class="pagination">
      <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
    </div>

    <toDetermine :data="determine_drawer" :isShow="determine_isShow" @onSubmit="verifyLists"></toDetermine>


    <determineContent :data="determine_drawer" :isShow="determineContent_show"></determineContent>

  </div>

</template>

<script>
  var _this;
  import toDetermine from './toDetermine.vue';
  import determineContent from './determineContent.vue';
  export default {
    components: {
      toDetermine,
      determineContent
    },
    data() {
      return {


        activeName:'all',



        // 传入子组件的数据
        determine_drawer: '',

        determineContent_show: false,

        // 详细搜索
        more_search: false,

        delDriverSubmit_rules: {
          driver_code_array: {
            placeholder: '权限模块',
            rules: {
              required: false,
              message: '权限模块代码数组(json)',
              regulation: 'special',
              rulesData: 'json_array'
            }
          }
        },
        // 抽屉开关按钮
        determine_isShow: false,

        // 下拉搜索管理状态
        value_status_code: '',
        value_status_array: '',

        // 存放表格数据
        tableData: [],

        //翻页数据
        search_data: {
          page: 1,
          limit: 10,
          real_name: '',
          verify_status: '',
          id_card: ''
        },

        result_data: [],
        search_rules: {
          page: {
            placeholder: '页码',
            rules: {
              required: true,
              message: '页码需要大于0',
              regulation: 'gt',
              rulesData: 0
            }
          },
          limit: {
            placeholder: '每页个数',
            rules: {
              required: true,
              message: '每页个数需在1-51之内',
              regulation: 'between',
              rulesData: [1, 51]
            }
          },

        },
      };
    },
    created() {
      _this = this;
      _this.verifyLists();

    },

    methods: {







      searchVerifyLists() {
        _this.search_data.page = 1;
        _this.verifyLists();
      },


      // 选项卡选中事件
      handleClick(tab, event) {
        // 点击的选项卡所对应的val值
        console.log(tab.name);
        if (tab.name != 'all') {
          _this.search_data.verify_status = tab.name;
        } else {
          _this.search_data.verify_status = '';
        }
        _this.search_data.page = 1;
        _this.verifyLists();

      },


      // 搜索司机审核列表
      verifyLists() {
        _this.$post(
            "/driver/getDriverVerifyLists",
            _this.search_data,
            _this.search_rules
          )
          .then(res => {

            // 将请求的数据存放到表格数据数组中
            _this.tableData = res.data;
            _this.result_data = res;

            _this.value_status_array = _this.tableData[0].verify_status.select_array;
          }).catch((err) => {

          })
      },
      //翻页组件的回调
      pages_function(search_data) {

        //赋值
        _this.search_data = search_data;
        //初始化列表
        _this.verifyLists();

      },

      handleSelectionChange(val) {

        var datalist = [];

        for (var i in val) {

          datalist.push(val[i].driver_code);

        }
        _this.delDriverSubmit_data.driver_code_array = datalist;
      },

      statusChange(val) {

        _this.search_data.verify_status = val;

      },



      // 刷新按钮
      refresh() {
        this.$router.go(0);
      }

    }
  };
</script>

<style scoped>
  .handle-box {
    margin-bottom: 20px;
  }

  .handle-select {
    width: 120px;
  }

  .handle-input {
    width: 200px;
    display: inline-block;
  }

  .table {
    width: 100%;
    font-size: 14px;
  }

  .red {
    color: #ff0000;
  }

  .mr10 {
    margin-right: 10px;
  }

  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }

  .el-table__row {
    height: 100px;
  }
</style>